import dataHubManager, { DataHubOperationType, DataHubStorageOperations } from '../../managers/data/DataHubManager'
import dataStorageManager, { BucketDefaultIDs } from '../../managers/data/DataStorageManager'
import { IArmador, OperatedArmador } from '../api-services/ArmadoresServices'
import { IChange, RequestedChange } from '../api-services/ChangesServices'
import { IRequest, RequestObjectType, RequestStatus } from '../api-services/RequestsServices'
import dataHubServices, { defaultRefreshTime, StorageService } from './DataHubServices'

export enum ChangesHubPipelines {
  VALID_CHANGES = 'valid_changes', // Pipeline para mostrar solo los cambios validos
  CHANGES_WITH_REQUESTS = 'changes_with_requests', // Para mostrar las solicitudes pendientes en el listado de cambios
  PENDING_CHANGES = 'pending_changes', // Pipeline para mostrar solo los cambios que tienen solicitudes pendientes
  CHANGES_FULL = 'changes_full', // Pipeline completo para mostrar toda la información relacionada a un cambio (solicitud, etc)
}

export const changesHubName = 'changesHub'

export class ChangesHub implements StorageService {
  bucketData: any[] = []

  storageOperations: DataHubStorageOperations<IArmador> = {
    getData: () => [],
    markDirty: () => {},
    markStaled: () => {},
    forceRefresh: async () => {},
  }
  pipelinesOperations: Map<ChangesHubPipelines, DataHubStorageOperations<any>> = new Map()

  constructor() {}

  public async startup() {
    dataStorageManager.subscribeBucket(BucketDefaultIDs.CAMBIOS, (data) => {
      this.bucketData = data
      this.storageOperations.forceRefresh()
    })
    this.storageOperations = dataHubManager.registerStorage(
      changesHubName,
      async () => {
        return this.bucketData
      },
      {
        invalidationStrategy: 'hybrid',
        checkTime: defaultRefreshTime,
        lazyLoad: true,
        pipelines: [
          {
            name: ChangesHubPipelines.VALID_CHANGES,
            operations: [
              {
                type: DataHubOperationType.FILTER,
                name: 'filterValidChanges',
                execute: (data: IChange[]) => {
                  const validChanges = data.filter((change) => change.log_cambios.includes(':'))
                  return validChanges
                },
              },
            ],
          },
          {
            name: ChangesHubPipelines.CHANGES_WITH_REQUESTS,
            operations: [
              {
                type: DataHubOperationType.MAP,
                name: 'addRequests',
                execute: (data: IChange[]) => {
                  const dataWithRequests = this.addRequestToChanges(data)
                  return dataWithRequests
                },
              },
            ],
          },
          {
            name: ChangesHubPipelines.PENDING_CHANGES,
            operations: [
              {
                type: DataHubOperationType.FILTER,
                name: 'filterPendingChanges',
                execute: (data: RequestedChange[]) => {
                  const pendingChanges = data
                    .filter((rc) => rc.requestData !== undefined)
                    .filter((rc) => rc.requestData!.estado === RequestStatus.PENDING) as RequestedChange[]
                  return pendingChanges
                },
              },
            ],
          },
        ],
      },
    )

    dataStorageManager.subscribeBucket(BucketDefaultIDs.SOLICITUDES, () => {
      console.log('Solicitudes updated, refreshing changes data...')
      this.storageOperations.forceRefresh()
    })
  }

  private addRequestToChanges(changes: IChange[]): Array<RequestedChange> {
    const requestsList = dataStorageManager.getCurrentBucketData<IRequest>(BucketDefaultIDs.SOLICITUDES) || []
    const requestedChanges: Array<RequestedChange> = changes.map((change) => {
      const requestData = requestsList
        .filter((req) => req.tipo_objeto === RequestObjectType.Modificacion)
        .filter((req) => req.id_objeto.toString() === change.id.toString())
        .sort((a, b) => new Date(b.fecha_solicitud).getTime() - new Date(a.fecha_solicitud).getTime())[0]
      return {
        ...change,
        requestData: requestData,
      }
    })
    return requestedChanges
  }
}
